import OrganizationUserEdit from 'src/components/Organization/pages/users/edit';

export default OrganizationUserEdit;
